import LBox from "@components/LBox";
import { useAuthSheet } from "@components/modals/AuthModal/useAuthSheet";
import { useFollow } from "@hooks/trpc/useFollow";
import { auth } from "@utils/firebase";
import LPressable from "@components/LPressable";
import LIcon from "@components/LIcon";

interface FollowButtonProps {
  artistId?: string;
}

const FollowButton = ({ artistId }: FollowButtonProps) => {
  const { followAction, isFollowing } = useFollow(artistId || "");
  const openAuthSheet = useAuthSheet();
  const isFollowed = Boolean(isFollowing);

  return (
    <LPressable
      accessibilityLabel={isFollowed ? "Unfollow artist" : "Follow artist"}
      accessibilityRole="button"
      hitSlop={12}
      onPress={() => {
        if (!auth.currentUser) {
          openAuthSheet();
          return;
        }
        followAction();
      }}
      sentryEventName={`${isFollowed ? "unfollow" : "follow"}_artist_${artistId}`}
    >
      <LBox
        alignItems="center"
        height={36}
        justifyContent="center"
        width={36}
      >
        <LIcon name="view_artist" size={30} />
        <LBox position="absolute" right={-1} top={-1}>
          <LIcon
            fill="white"
            name={isFollowed ? "check" : "plus_simple"}
            size={12}
          />
        </LBox>
      </LBox>
    </LPressable>
  );
};

export default FollowButton;
